import React, { useState } from "react";

import { Loader2 } from "lucide-react";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";
import { Button } from "./ui/button";

export function CommonDialog({
  open,
  setOpen,
  title,
  description,
  isYesNo = true,
  onConfirm,
}) {
  const [isWorking, setIsWorking] = useState(false);

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>

        {isYesNo ? (
          <AlertDialogFooter>
            <Button
              variant="outline"
              disabled={isWorking}
              className="min-w-[50px]"
              onClick={() => setOpen(false)}
            >
              No
            </Button>

            <Button
              disabled={isWorking}
              className="min-w-[50px]"
              onClick={async () => {
                try {
                  setIsWorking(true);

                  // Do work
                  await onConfirm();

                  // Close dialog
                  setOpen(false);
                } finally {
                  setIsWorking(false);
                }
              }}
            >
              {isWorking ? (
                <>
                  <Loader2 className="h-4 w-4 animate-spin" />
                </>
              ) : (
                <>
                  <span>Yes</span>
                </>
              )}
            </Button>
          </AlertDialogFooter>
        ) : (
          <AlertDialogFooter>
            <Button
              className="min-w-[90px]"
              disabled={isWorking}
              onClick={async () => {
                try {
                  setIsWorking(true);

                  // Do work
                  await onConfirm();

                  // Close dialog
                  setOpen(false);
                } finally {
                  setIsWorking(false);
                }
              }}
            >
              {isWorking ? (
                <>
                  <Loader2 className="h-4 w-4 animate-spin" />
                </>
              ) : (
                <>
                  <span>Confirm</span>
                </>
              )}
            </Button>
          </AlertDialogFooter>
        )}
      </AlertDialogContent>
    </AlertDialog>
  );
}
